import type { SVGProps } from "react";

export const PointerHorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 10"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.586 1.414a2 2 0 0 1 2.828 0L20 10H0z"
    />
  </svg>
);
